'use client';

import { Column, Element } from '@vuddy/components';
import * as styles from './classPurchaseBottomSheet.css';
import type { ClassVoucher } from './classVoucherContext';
import { ClassVoucherItem } from './ClassVoucherItem';

interface ClassVoucherListProps {
  vouchers: ClassVoucher[];
  disabledVoucherIds?: string[];
  onCodeInputClick?: (voucherId: string) => void;
  // key: voucherId, value: 검증된 promotionCode
  verifiedVoucherCodes?: Map<string, string>;
}

export const ClassVoucherList = ({
  vouchers,
  disabledVoucherIds = [],
  onCodeInputClick,
  verifiedVoucherCodes,
}: ClassVoucherListProps) => {
  const disabledSet = new Set(disabledVoucherIds);

  return (
    <Element as="div" className={styles.listContainer}>
      <Column gap="gap_xl">
        {vouchers.map(voucher => (
          <ClassVoucherItem
            key={voucher.id}
            voucher={voucher}
            disabled={disabledSet.has(voucher.id)}
            hasVerificationCode={voucher.requiresPromotionCode}
            verificationCodeName={verifiedVoucherCodes?.get(voucher.id)}
            onCodeInputClick={onCodeInputClick}
          />
        ))}
      </Column>
    </Element>
  );
};
